import { CONTAINER_ID, LABEL_ID, RADIO_ID } from '../constants/locators';

type UseRadioButtonLocatorsProps = {
  key: string;
};

export const useRadioButtonLocators = ({ key }: UseRadioButtonLocatorsProps) => {
  return {
    containerNodeId: `${CONTAINER_ID}--${key}`,
    radioNodeId: `${RADIO_ID}--${key}`,
    labelNodeId: `${LABEL_ID}--${key}`,
  };
};
